"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(pathname) {
  return {
    pathname: pathname,
    listen: function listen() {
      return function () {};
    }
  };
};

exports.default = _default;
module.exports = exports.default;